import { clearApplicantState, setCredentialsCreated } from "@/slices/applicantSlice";
import { clearApplicationState } from "@/slices/applicationSlice";
import {
  clearCredentialState,
  setAccessToken,
  setRefreshToken,
  setTokenExpiration,
} from "@/slices/credentialSlice";
import { RootState } from "@/store/dtm";
import React, { createContext, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { clearReferralProductsState } from "@/slices/referralProductSlice";


interface AuthContextType {
  login: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>(null!);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const login = (accessToken: string, refreshToken: string) => {
    dispatch(setAccessToken(accessToken != undefined ? accessToken : ""));
    dispatch(setRefreshToken(refreshToken != undefined ? refreshToken : ""));
    dispatch(setTokenExpiration(dayjs().add(60, 'minute').toISOString()));
  };
  const logout = () => {
    dispatch(clearCredentialState());
    dispatch(setCredentialsCreated(false));
    dispatch(clearApplicationState());
    dispatch(clearApplicantState());
    dispatch(clearReferralProductsState());
    navigate("/login");
  };

  const handleOnIdle = () => {
    // Implement logout functionality here
    logout();
  };

  const idleTimer = useIdleTimer({
    timeout: 1000 * 60 * 10, // 10 minutes
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return (
    <AuthContext.Provider value={{ login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);